<template>
  <div class="header">
    <router-link :to=" { path:'/' } ">
      <img src="../../assets/images/logo.png" class="logo" alt="">
    </router-link>
    <img src="../../assets/images/menu.png" class="btn" alt="" @click="clickMenu()">
    <!-- 右侧弹出层 -->
    <nut-popup
      position="right"
      v-model:visible="show"
      pop-class='pop'
      :style="{ height: '100%', width: '60%' }"
    >
    <div class="menu">
      <img src="../../assets/images/close.png" class="img" alt="" @click="clickMenu()">
      <ul>
        <router-link :to=" { path:'/' } "><li>首页</li></router-link>
        <router-link :to=" { path:'/newsList' } "><li>新闻资讯</li></router-link>
        <router-link :to=" { path:'/productList' } "><li>产品解决方案</li></router-link>
        <router-link :to=" { path:'/cooperate' } "><li>合作伙伴</li></router-link>
        <router-link :to=" { path:'/about' } "><li>关于博雅数字</li></router-link>
      </ul>
    </div>
    </nut-popup>
  </div>
</template>
<script>
export default {
  components: {

  },
  data() {
    return {
      show: false,
    }
  },
  created() {

  },
  methods: {
    clickMenu() {
      this.show = !this.show;
    },
  }
}
</script>
<style scoped>
.header {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 1000;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 28px 32px;
  box-sizing: border-box;
  background: #fff;
}
.header .logo {
  display: block;
  width: 232px;
  height: 64px;
}
.header .btn {
  display: block;
  width: 48px;
  height: 48px;
}
.img {
  display: block;
  width: 48px;
  height: 48px;
  position: absolute;
  top: 36px;
  right: 32px;
  /* display:flex;
  align-items:flex-end; */
}
.menu ul {
  padding: 100px 32px;
  box-sizing: border-box;
}
.menu ul li {
  font-size: 24px;
  line-height: 80px;
  font-weight: 500;
  border-bottom: 1px solid #ededed;
}

</style>